import  { FC, useState} from "react";
import { Accordion, AccordionSummary,  Paper,  IconButton, TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow, Table, Checkbox, Chip, Tooltip } from "@material-ui/core";

import { ExpandMore } from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";

import { makeStyles } from '@material-ui/core/styles';

import { download } from "../../fetchers/fetchers";
import GetAppIcon from '@material-ui/icons/GetApp';
import { CircularProgress } from "@material-ui/core";
import { API_URL } from "../../env";
import fileDownload from 'js-file-download';

import { useParams } from "react-router";


const useStyles = makeStyles({

  
    tableHeader: {
        backgroundColor: 'lightgrey',
    },
    tableHeaderCell: {
        textAlign: 'center',
    },



});

interface ISokProps {
    prioritisationData: any,

}


interface IRouteParams {
    id: string
}

const ConfidenceChip = (confidence_id: number | string) => {
    // Convert to number if it's a numeric string
    let value = confidence_id;
    if (typeof confidence_id === 'string' && !isNaN(Number(confidence_id))) {
        value = Number(confidence_id);
    }

    // Handle string values like "Undefined", "Strong", etc.
    if (typeof value === 'string') {
        let bcolor = "rgb(196,196,196)";
        let color = "#535353";
        const label = value;

        const lowerLabel = value.toLowerCase();
        if (lowerLabel === 'very strong') {
            bcolor = "rgba(0,176,80,1)";
            color = "rgb(0,0,0)";
        } else if (lowerLabel === 'strong') {
            bcolor = "rgba(206,238,208,1)";
            color = "rgb(48,104,33)";
        } else if (lowerLabel === 'weak') {
            bcolor = "rgba(252,236,166,1)";
            color = "rgb(152,96,34)";
        } else if (lowerLabel === 'very weak') {
            bcolor = "rgba(251,84,81,1)";
            color = "rgb(104,4,0)";
        }

        return (
            <Tooltip title={label}>
                <Chip
                    size="small"
                    label={label}
                    style={{backgroundColor: bcolor, color: color}}
                />
            </Tooltip>
        );
    }

    // Handle numeric values
    if (value === null || value === undefined || value === 0 || value === -1) {
        return (
            <Tooltip title="Undefined">
                <Chip
                    size="small"
                    label="Undefined"
                    style={{backgroundColor: "rgb(196,196,196)", color: "#535353"}}
                />
            </Tooltip>
        );
    }

    let bcolor = "rgb(196,196,196)";
    let color = "#535353";
    let label = "Undefined";

    if (value === 1) {
        bcolor = "rgba(0,176,80,1)";
        color = "rgb(0,0,0)";
        label = "Very Strong";
    } else if (value === 2) {
        bcolor = "rgba(206,238,208,1)";
        color = "rgb(48,104,33)";
        label = "Strong";
    } else if (value === 3) {
        bcolor = "rgba(252,236,166,1)";
        color = "rgb(152,96,34)";
        label = "Weak";
    } else if (value > 3) {
        bcolor = "rgba(251,84,81,1)";
        color = "rgb(104,4,0)";
        label = "Very Weak";
    }

    return (
        <Tooltip title={label}>
            <Chip
                size="small"
                label={label}
                style={{backgroundColor: bcolor, color: color}}
            />
        </Tooltip>
    );
}



const PrioritisationSummaryTable: FC<ISokProps> = ({ prioritisationData }) => {

    const classes = useStyles();

    const params = useParams<IRouteParams>()

    const [isDownloading, setIsDownloading] = useState(false);
    const [downloadError, setDownloadError] = useState<string | null>(null);



    const downloadFile = async () => {
        return await download(API_URL + "prioritisation/" + params.id + "/?scope=all");
    }

    
    const handleDownloadClick = async () => {
        if (isDownloading) return;
        setDownloadError(null);
        setIsDownloading(true);
        try {
            const { data, filename } = await downloadFile();
            fileDownload(data, filename);
        } catch {
            setDownloadError("The export could not be downloaded. Please try again.");
        } finally {
            setIsDownloading(false);
        }
    };

    const order_of_mag = (control_measure_cost: number) :string => {
        const order_of_magnitute = [
            {limit: 1, label: "<1" },
            {limit: 2, label: "1-2"},
            {limit: 5, label: "2-5"},
            {limit: 10, label: "5-10"},
            {limit: 20, label: "10-20" },
            {limit: 50, label: "20-50" },
            {limit: 100, label: "50-100" },
            {limit: 1000000000, label: "> 100" },
        ]

        let level = order_of_magnitute.length - 1
        for (let i = order_of_magnitute.length - 1; i > -1; i--) {
            if (control_measure_cost / 1000000 > order_of_magnitute[i].limit ) {
                break
            }
            level = i
        }

        return order_of_magnitute[level].label
    }

      return (
        <>
            <Accordion expanded={true}>
                <AccordionSummary id={"1"} expandIcon={<ExpandMore /> }>
                    <Typography variant="h6"> 
                    Prioritisation 
                    <Tooltip title="Download all additional control measures. This may take a while.">
                        <span>
                            <IconButton onClick={handleDownloadClick} disabled={isDownloading} aria-label="Download all additional control measures">
                                {isDownloading ? <CircularProgress size={24} /> : <GetAppIcon />}
                            </IconButton>
                        </span>
                    </Tooltip>
                    
                    </Typography>
                </AccordionSummary>
                <Typography variant="body2" color="textSecondary" role="status" style={{ padding: '0 16px 16px' }}>
                    {isDownloading
                        ? "Preparing the complete export. This may take a while. Please keep this page open; your download will start automatically when it is ready."
                        : "The complete export includes all additional control measures and may take a while to prepare."}
                </Typography>
                {downloadError && (
                    <Typography variant="body2" color="error" role="alert" style={{ padding: '0 16px 16px' }}>
                        {downloadError}
                    </Typography>
                )}
                <TableContainer component={Paper}>
            <Table>
                <TableHead className={classes.tableHeader}>
                    <TableRow>
                    <TableCell className={classes.tableHeaderCell} >Dam</TableCell>
                        <TableCell className={classes.tableHeaderCell} >Order</TableCell>
                        <TableCell className={classes.tableHeaderCell}>Contorl Measure</TableCell>
                        <TableCell className={classes.tableHeaderCell}>De Minimis</TableCell>
                        <TableCell className={classes.tableHeaderCell}>Assessment</TableCell>
                        <TableCell className={classes.tableHeaderCell}>Tier</TableCell>
                        <TableCell className={classes.tableHeaderCell}>Societal Risk Confidence</TableCell>
                        <TableCell className={classes.tableHeaderCell}>Individual Risk Confidence</TableCell>
                        <TableCell className={classes.tableHeaderCell}>Order of magnitude of Costs ($M)</TableCell>
                        <TableCell className={classes.tableHeaderCell}>Societal Risk Before</TableCell>
                        <TableCell className={classes.tableHeaderCell}>Societal Risk After</TableCell>
                        <TableCell className={classes.tableHeaderCell}>Incremental Risk Reduction</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {prioritisationData.map((row: any) => (
                        <TableRow key={row.dam_name}>
                            <TableCell>{row.dam_name}</TableCell>
                            <TableCell>{row["Portfolio Wide Priority"]}</TableCell>
                            <TableCell>{row["Risk Control Measure (RCM)"]}</TableCell>
                            <TableCell>
                                <Checkbox checked={row["de_minimis"]} disabled />
                            </TableCell>
                            <TableCell>{row["Reasonably Practicable Assessment"]}</TableCell>
                            <TableCell>{row["tier"]}</TableCell>
                            <TableCell>{ConfidenceChip(row["societal_confidence_id"])}</TableCell>
                            <TableCell>{ConfidenceChip(row["individual_confidence_id"])}</TableCell>
                            <TableCell className="">{order_of_mag(row["cost"] as number)}</TableCell>
                            <TableCell className="">{parseFloat(row["societal_risk_before"]).toExponential(2)}</TableCell>
                            <TableCell className="">{parseFloat(row["societal_risk_after"]).toExponential(2)}</TableCell>
                            <TableCell className="">{parseFloat(row["incremental risk reduction"]).toExponential(2)}</TableCell>
                        </TableRow>
                    ))}


                </TableBody>
            </Table>
        </TableContainer>
            </Accordion>

        </>
    )
}


export default PrioritisationSummaryTable;
